module.exports = __webpack_public_path__ + "static/media/feishu_OKR.721f6258.png";